import { navigate } from '@gatsbyjs/reach-router';

import { createPayment } from '@api/backendAPI';

export const usePlaidOnSuccess = (
  isOauth,
  basepath,
  orderId,
  amount,
  setDisplayProcessingModal,
  setLinkToken,
  setDisplayAmountConfirmationModal,
  setPaymentError
) => {
  let plaidOauthObject = null;
  let oAuthPaymentAmount = null;
  if (isOauth) {
    plaidOauthObject = localStorage.getItem('plaidOauthObject');
    oAuthPaymentAmount = JSON.parse(plaidOauthObject)?.amount;
  }
  return async (
    publicToken,
    { account_id: accountId, link_session_id: linkSessionId }
  ) => {
    setDisplayProcessingModal(true);
    try {
      await createPayment(
        publicToken,
        accountId,
        isOauth ? oAuthPaymentAmount : amount.current,
        orderId,
        linkSessionId
      );
      await navigate(
        `${window.location.origin}${basepath}orders/${orderId}/payments/confirmation`
      ).then(() => window.location.reload());
    } catch (e) {
      if (isOauth) {
        // eslint-disable-next-line no-console
        console.error(e);
        await navigate(`${basepath}orders/${orderId}/payments`);
      } else {
        // eslint-disable-next-line no-console
        console.error(e);
        setPaymentError(true);
        setLinkToken('');
        setDisplayAmountConfirmationModal(true);
      }
    }
    setDisplayProcessingModal(false);
  };
};
